export default __webpack_public_path__ + "static/media/elastic.a9e1a9d5.svg";